export default __webpack_public_path__ + "static/media/lynnMain.751aaa22.png";